import { LegalPage } from './legal/LegalPage';
import { doc } from './legal/content/cookie-policy';

export const Cookie = () => <LegalPage doc={doc} />;
